module.exports = __webpack_public_path__ + "static/media/desktop1.698928ac.png";